import React from 'react';
import { FaStar } from 'react-icons/fa';
import '../styles/ExperienceCard.css';

const ExperienceCard = ({ experience, onClick, index }) => {
  // Debug: log the experience data to see what we're working with
  console.log('Experience data:', experience);
  
  const cardStyle = experience.imageUrl ? 
    { 
      backgroundImage: `linear-gradient(rgba(0,0,0,0.4), rgba(0,0,0,0.4)), url(${experience.imageUrl})`,
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      backgroundRepeat: 'no-repeat'
    }
    : {};
  return (
        <div 
      className={`experience-card ${!experience.imageUrl ? `card-gradient-${index % 4}` : ''}`}
      style={cardStyle}
      onClick={onClick}
    >
      <div className="card-info-top">
        {experience.year && <span className="year-badge">{experience.year}</span>}
        {experience.rating > 0 && (
          <div className="rating-display">
            {[...Array(5)].map((_, i) => (
              <FaStar key={i} size={16} color={i < experience.rating ? '#ffc107' : 'rgba(255,255,255,0.5)'} />
            ))}
          </div>
        )}
      </div>
      <div className="card-content">
        <h3>{experience.title}</h3>
      </div>
    </div>
  );
};

export default ExperienceCard;
